/** Extracts the video ID from any YouTube URL/share format. */
function extractYouTubeId(url) {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([\w-]{11})/i,
    /^([\w-]{11})$/, // bare id
  ];
  for (const re of patterns) {
    const m = url.match(re);
    if (m && m[1]) return m[1];
  }
  return null;
}

/** Renders a YouTube video as an embedded iframe (16:9). Use on vendor profiles. */
export default function YouTubeEmbed({ url, title = 'Vendor video', className = '' }) {
  const id = extractYouTubeId(url);
  if (!id) return null;
  return (
    <div className={`relative w-full overflow-hidden rounded-2xl bg-black ${className}`} style={{ paddingBottom: '56.25%' }} data-testid="youtube-embed">
      <iframe
        title={title}
        src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`}
        className="absolute inset-0 w-full h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
}

export { extractYouTubeId };
